// src/services/queries/charts/chartQueries.ts

import { API_BASE_URL } from "@/services/";
import type { HistoryResponse } from "@/types/charts";

// New batched history fetcher
export async function fetchHistoryBatched(
  kind: "metrics" | "ratios",
  args: {
    categoryId: number;
    keys?: string[];
    signal?: AbortSignal;
  }
): Promise<HistoryResponse> {
  const { categoryId, keys, signal } = args;
  const params = new URLSearchParams();
  params.set("category_id", String(categoryId));
  if (keys && keys.length > 0) {
    params.set(kind === "metrics" ? "metric_keys" : "ratio_keys", keys.join(","));
  }

  const url = `${API_BASE_URL}/history/${kind}?${params.toString()}`;
  const init: RequestInit = {};
  if (signal) init.signal = signal as unknown as AbortSignal;
  const res = await fetch(url, init);
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  return res.json();
}
